// ═══════════════════════════════════════════════════════════════
// API: Importación masiva de empleados
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const employeeImportAPI = {

  // Descargar plantilla Excel (fetch con token para incluir auth headers)
  downloadTemplate: async () => {
    const response = await api.get('/employee-import/template', {
      responseType: 'blob',
      timeout: 30000
    });
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'plantilla_empleados_7family.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  },

  // Subir archivo y validar (sin guardar)
  validate: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/employee-import/validate', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000 // 2 min para archivos grandes
    });
    return response.data;
  },

  // Confirmar e importar los válidos
  confirm: async (importId, modo = 'solo_validos') => {
    const response = await api.post(`/employee-import/confirm/${importId}`, { modo });
    return response.data;
  },

  // Historial de importaciones
  getHistory: async (params = {}) => {
    const response = await api.get('/employee-import/history', { params });
    return response.data;
  }
};

export default employeeImportAPI;
